import {
  put, call, all, select,
} from 'redux-saga/effects';

import { Creators as UiCreators } from '../ducks/ui';
import { getCompanyId } from '../ducks/company';
import { getTasksByCompanyAndUserId, getTask } from '../../services/api/task';
import { Creators as CreatorsTask } from '../ducks/task';

export function* getTaskByUser({ payload }) {
  try {
    yield put(UiCreators.showLoader('TASK'));
    const companyId = yield select(getCompanyId);
    const data = yield call(getTasksByCompanyAndUserId, companyId, payload.id);

    if (data.success) {
      yield put(CreatorsTask.getTaskSuccess(data.user_tasks.reverse()));
      yield put(UiCreators.hideLoader('TASK'));
    }

    // com token
  } catch (error) {
    yield all([put(UiCreators.hideLoader('TASK'))]);
  }
}

export function* getTaskDetails({ idTask }) {

  try {
    yield put(UiCreators.showLoader('TASK_DETAILS'));
    const data = yield call(getTask, idTask);
    if (data.success) {
      yield put(CreatorsTask.getTaskDetailsSuccess(data.task));
      yield put(UiCreators.hideLoader('TASK_DETAILS'));
    }

    // com token
  } catch (error) {
    yield all([put(UiCreators.hideLoader('TASK_DETAILS'))]);
  }
}
